import { Component, HostListener, OnInit } from "@angular/core";
import { About } from "app/service/page/page";
import { PageService } from "app/service/page/page.service";

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss'],
  providers: [PageService]
})
export class AboutComponent implements OnInit {
  isMobile: boolean = false;
  about = {} as About.Res;

  constructor(private pageService: PageService) {
    this.pageService.getAbout().subscribe(
      res => {
        this.about = res;
        this.renderSwiper(res.sliders);
      }
    );
  }

  ngOnInit() {
    this.swiper = new Swiper('.swiper-main-slider', this.config);
    this.isMobile = (window.innerWidth < 768);
    this.swiperWidth = window.innerWidth > 1168 ? window.innerWidth - ((window.innerWidth - 1136) / 2) : 1152
  }

  renderSwiper(sliders) {
    this.swiper.removeAllSlides();
    this.swiper.appendSlide(sliders.map(
      slide => {
        let rtn = `<div class="swiper-slide" style="background-image:url('${this.isMobile ? slide.mobileImage : slide.image}')">`
        rtn += `</div>`
        
        return rtn
      })
    );
    this.swiper.update(true);
    this.swiper.slideTo(1, 0); 
  }

  @HostListener('window:resize', ['$event']) onResize(event) {
    let isMobile = (event.target.innerWidth < 768);
    this.swiperWidth = event.target.innerWidth > 1184 ? event.target.innerWidth - ((event.target.innerWidth - 1136) / 2) : 1152
    if (this.isMobile != isMobile) {
      this.isMobile = isMobile;
      this.renderSwiper(this.about.sliders);
    }
  }

  swiper;
  swiperWidth = 0;
  config = {
    scrollbar: null,
    direction: 'horizontal',
    slidesPerView: 1,
    scrollbarHide: false,
    keyboardControl: false,
    mousewheelControl: false,
    scrollbarDraggable: true,
    scrollbarSnapOnRelease: true,
    nextButton: '.swiper-button-next',
    prevButton: '.swiper-button-prev',
    autoplayStopOnLast: false,
    autoplayDisableOnInteraction: false,
    watchSlidesProgress: true,
    watchSlidesVisibility: true,
    autoplay: 3000,
    loop: true,
    pagination: '.swiper-pagination',
    paginationType: 'bullets',
    paginationClickable: true,
  };
}


// WEBPACK FOOTER //
// ./src/app/heyground/about/about.component.ts